import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getRackProductsAction, handleSelectedViewStockAction, loadingToggleSingleRackAction } from '../../../store/actions/RackActions';
import Pagination from '../../constant/Pagination';
import DataLoader from '../Dashboard/Loader';
import ExportExcelRackProductBtn from './ExportRackProductBtn';

const ViewProduct = () => {
    let { id } = useParams();
    const navigate = useNavigate()
    const store = useSelector(state => state)
    const { selectRackProducts, selectProductStock, isLoadingSingleRack } = store.racks
    const { role, user_permission } = store.auth.user

    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageProductStock, setCurrentPageProductStock] = useState(1);
    const recordsPage = 10;

    useEffect(() => {
        dispatch(loadingToggleSingleRackAction(true))
        dispatch(getRackProductsAction(id))
    }, [dispatch, id])

    const handleViewStock = (prod_id) => {
        dispatch(handleSelectedViewStockAction(prod_id))
    }

    const handlePagination = (page) => {
        const new_page = page.selected + 1
        setCurrentPage(new_page)
    }

    const handlePaginationProductStock = (page) => {
        const new_page = page.selected + 1
        setCurrentPageProductStock(new_page)
    }

    return (isLoadingSingleRack ? <DataLoader height={"40rem"} marginTop={'20rem'} /> :
        <>
            {selectRackProducts != null ? (
                <div className="container-fluid">
                    <div className="row">
                        <div className='col-xl-6'>
                            <div className="card">
                                <div className="card-body p-0">
                                    <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
                                        <div className="d-flex align-items-center">
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary btn-sm rounded-circle"
                                                style={{ padding: "5px 9px" }}
                                                onClick={() => navigate("/rack")}
                                            ><i className="fa-solid fa-arrow-left"></i></button>
                                            <h4 className="mb-0 ms-2">Rack Details - {selectRackProducts.rack.rack_no}</h4>
                                        </div>

                                        {(role === "Admin" || user_permission.manage_rack) &&
                                            <ExportExcelRackProductBtn
                                                data={
                                                    selectRackProducts.products.map(row => (
                                                        [row.name, row.ucs_code, row.net_quantity]
                                                    ))
                                                }
                                                headers={['Product Name', 'UCS Code', 'Total Quantities',]}
                                                fileName={`${selectRackProducts.rack.rack_no}-rack-products-data`}
                                            />
                                        }

                                    </div>

                                    <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                        <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                            <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Material</th>
                                                        <th>UCS Code</th>
                                                        <th>Total Quantity</th>
                                                        <th>View Stock</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {selectRackProducts.products.length ? selectRackProducts.products.slice((currentPage - 1) * recordsPage, currentPage * recordsPage).map((st, ind) => (
                                                        <tr key={ind}>
                                                            <td><Link to={`/material/${st.id}`}>{st.name}</Link></td>
                                                            <td><span>{st.ucs_code}</span></td>
                                                            <td><span>{st.net_quantity}</span></td>
                                                            <td>
                                                                <button type='button' onClick={() => { handleViewStock(st.id) }} className='btn btn-sm btn-outline-primary' disabled={st === selectProductStock}>View Stock</button>
                                                            </td>
                                                        </tr>
                                                    )) : <tr>
                                                        <td colSpan="4" className="text-center">No Product Found</td>
                                                    </tr>}
                                                </tbody>

                                            </table>
                                        </div>
                                    </div>
                                    <div className='px-2'>
                                        <Pagination
                                            currentPage={currentPage}
                                            recordsPage={recordsPage}
                                            dataLength={selectRackProducts.products.length}
                                            handlePagination={handlePagination}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* col-end */}

                        <div className='col-xl-6'>
                            <div className="card">
                                {selectProductStock ?
                                    <div className="card-body p-0">
                                        <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
                                            <h4 className="mb-0 ms-2">Stock Details - {selectProductStock?.name}</h4>

                                            {(role === "Admin" || user_permission.manage_rack) &&
                                                <ExportExcelRackProductBtn
                                                    data={
                                                        selectProductStock?.stocks.map(row => (
                                                            [row.barcode, `${row.quantity} ${row.expired_date && row.expired_date}`, row.created_at]
                                                        ))
                                                    }
                                                    headers={['Barcode', 'Quantity', "Stock In Date"]}
                                                    fileName={`rack-${selectRackProducts?.rack?.rack_no}-product-${selectProductStock?.name}-stock-data`}
                                                />
                                            }

                                        </div>
                                        <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                            <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                                <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Barcode</th>
                                                            <th>Quantity</th>
                                                            <th>Stock In Date</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {selectProductStock?.stocks.slice((currentPageProductStock - 1) * recordsPage, currentPageProductStock * recordsPage).map((st, ind) => (
                                                            <tr key={ind}>
                                                                <td><span>{st.barcode}</span></td>
                                                                <td><span>{st.quantity} {st.expired_date &&
                                                                    <span className={`ms-2 fw-light ${new Date() > new Date(st.expired_date) ? 'text-danger' : ''}`}>
                                                                        <i className="fa-regular fa-clock"></i> {st.expired_date}</span>
                                                                }</span></td>
                                                                <td><span>{st.created_at}</span></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className='px-2'>
                                            <Pagination
                                                currentPage={currentPageProductStock}
                                                recordsPage={recordsPage}
                                                dataLength={selectProductStock?.stocks?.length || 0}
                                                handlePagination={handlePaginationProductStock}
                                            />
                                        </div>
                                    </div>
                                    :
                                    <div className='card-body p-0'>
                                        <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
                                            <h4 className="mb-0 ms-2">Stock Details</h4>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            ) : <h2>Invalid Rack Id {id}</h2>}
        </>
    );
};

export default ViewProduct;